import { customerHelper } from '@homeserve/vue-api-plugin';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Route } from 'vue-router';
import { diagnosticHelper } from '../store';
import { RawLocation } from 'vue-router/types/router';
import { VueGtmTrackEventParams } from 'vue-gtm/dist/plugin';

export function handleRouteChange(this: Vue, store: any, to: Route) {
  let eventOptions: VueGtmTrackEventParams = {
    event: 'content-view',
    path: to.fullPath,
    pageType: to.meta ? to.meta.gtm : '',
    partner: store.getters.partner.name,
  };

  if (this.gtmRouterInfo) {
    eventOptions = { ...eventOptions, ...this.gtmRouterInfo };
  }

  const postCodeObj = diagnosticHelper.getPostCode(store);
  const customer = customerHelper.getCustomer(store);

  if (postCodeObj && postCodeObj.postCode) {
    eventOptions.visitorPostalCode = postCodeObj.postCode;
  }

  if (customer && customer.id) {
    eventOptions.customerId = customer.id;
  }

  this.$gtm.trackEvent(eventOptions);
}

export type nextCallbackType = (to?: RawLocation | false | ((vm: Vue) => any) | void) => void;

@Component
export default class GTMPageViewingMixin extends Vue {
  public beforeRouteEnter(to: Route, from: Route, next: nextCallbackType) {
    next(vm => {
      handleRouteChange.call(vm, vm.$store, to);
    });
  }

  public beforeRouteUpdate(to: Route, from: Route, next: nextCallbackType) {
    handleRouteChange.call(this, this.$store, to);
    next();
  }
}
